/**
 * Brand Constants
 * Add your brand details here.
 */
export const EMAIL_DOMAIN = 'webhook.inboxbridge.io'

const SITE_URL = 'https://inboxbridge.io'
const SITE_IMAGE_PATH = '/images/og-image.svg'

export const siteConfig = {
  siteTitle: 'Inbox Bridge',
  siteDescription:
    'Inbox Bridge turns inbound emails into webhooks. Get a unique email address, receive parsed JSON at your endpoint — with retries, replay, and delivery logs.',
  siteUrl: SITE_URL,
  siteImage: SITE_IMAGE_PATH,
  siteImageUrl: `${SITE_URL}${SITE_IMAGE_PATH}`,
  favicon: '/favicon.ico',
  twitterHandle: '',
  email: 'hello@inboxbridge.io',
  address: '',
}

export function absoluteUrl(path: string): string {
  if (path.startsWith('http')) return path
  return `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`
}
